<div id="fbx_wrapper" class="alert alert-error" role="alert" *ngIf="errors.length > 0" aria-labelledby="fbx_title_txt">
    <p class="fbx-header" id="fbx_title_txt">Aufgetretene Fehler:</p>
    <ul id="fbx_uli" aria-live="polite">
        <li *ngFor="let error of errors; let i = index" id="fbx_item_{{ i }}_li">
            <a
                id="fbx_item_{{ i }}_lnk"
                (click)="scrollToElement(error, $event)"
                [attr.aria-controls]="error.targetElement.id"
                class="ba-link ba-link-secondary"
                href
                >{{ error.label?.replace('*', '') }}</a
            >
            - <span id="fbx_item_{{ i }}_txt">{{ error.errorMessage }}</span>
        </li>
    </ul>
</div>
